<template>
  <div class="py-4 container-fluid">
    <div v-if="userClass=='superadmin'||userClass=='executive'||userClass=='admin'" class="row">
      <div class="col-md-6 pb-4 small">
        <div class="pl-3">
          <span
            v-if="showNavDash('home')"
            style="cursor:pointer" 
            :class="'badge badge-sm me-1 '+isDashboardActive(1)" 
            @click="GetDashboard(1)"> 
            Home  
          </span>
          <span
            v-if="showNavDash('enumeration')" 
            style="cursor:pointer" 
            :class="'badge badge-sm me-1 '+isDashboardActive(2)"   
            @click="GetDashboard(2)"> 
            Verification
          </span>
          <span
            v-if="showNavDash('trends')" 
            style="cursor:pointer" 
            :class="'badge badge-sm me-1 '+isDashboardActive(3)"   
            @click="GetDashboard(3)"> 
            Trends
          </span>
        </div>
      </div>
      <div class="col-md-6 pb-4 small d-none d-lg-block" style="text-align:right">
        <span class="badge badge-sm me-1 bg-gradient-info" title="Default dashboard preference : Home" style="cursor:pointer">
          <i class="fas fa-save" aria-hidden="true"></i>
        </span>
      </div>
    </div>
    <home v-if="dashboard==1" ></home>
    <Verification v-else-if="dashboard==2"></Verification>
    <Trends v-else-if="dashboard==3"></Trends>
  </div>
</template>
<script>
import Home from "@/views/dashboard/Home.vue";
import Verification from "@/views/dashboard/Verification.vue";
import Trends from "@/views/dashboard/Trends.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      dashboard : 3,
      userClass : '',
      admin : '',
    };
  },
  created(){
    this.getUserClass();
  },
  components: {
    Verification,
    Home,
    Trends
  },
  methods : {

    GetDashboard(type)
    {
       this.dashboard = type
    },

    isDashboardActive(type)
    {
      if(type==this.dashboard)
      { 
        return 'bg-gradient-info';
      }
      else
      { 
        return 'bg-gradient-secondary';
      }
    },

    getUserClass()
    {
      if(this.$store.getters.isLoggedIn)
      {
        this.userClass = this.$store.getters.getUser.primaryRole.name;
        this.admin = (this.userClass=='enumeration_admin'||'registration_admin')? 'admin' : '';

        // # [ Debugger ]
        // console.log('# Render User Class');
        // console.log(this.admin);

        switch(this.userClass)
        {
           case 'superadmin' : case 'executive' : case 'admin' : this.dashboard = 1; break;
           case 'enumeration_admin' : this.dashboard = 3; break;
           case 'registration_admin' : this.dashboard = 2; break;
           case 'bank': this.dashboard = 5; break;
           default : this.dashboard = 3;
        }
        
      }
    },

    showNavDash(dashUser = '')
    {
        var show = false;

        if(this.userClass=='superadmin'||this.userClass=='executive'||this.userClass=='admin')
        {
            show = true; dashUser = '';
        }

        switch(dashUser)
        {
            case 'home':
              show = (this.userClass=='enumeration_admin'||this.userClass=='registration_admin')? true  : false; 
            break;
            case 'enumeration': 
              show = (this.userClass=='enumeration_admin'||this.userClass=='focal_manager')? true : false;
            break;
            case 'registration': 
              show = (this.userClass=='registration_admin'||this.userClass=='focal_manager')? true : false;
            break;
            case 'loan': 
              show = (this.userClass=='bank')? true : false;
            break;
            case 'trends':
              // Trends is visible for the same users who can see other dashboards
              show = (this.userClass=='superadmin'||this.userClass=='executive'||this.userClass=='admin')? true : false;
            break;
        }

        return show;
    }
  }
};
</script>
